import * as echarts from '../../../libs/echarts';
import dateFormats from '../../../helpers/dateFormats';

export default async function generateHtmlPageForExport(node, config) {
  const headerDateCreation = dateFormats.formatDateNoTime(new Date());
  const range = config.reportRange;
  const year = config.reportYear;
  const fileName = config.fileName;
  const parser = new DOMParser();
  const doc = parser.parseFromString(node.outerHTML, 'text/html');

  const barsLegend = doc.querySelector('.export_html_legend');
  const milestoneLegend = doc.querySelector('.export_html_milestone_chart_legend');
  const pieChartLegend = doc.querySelector('.export_html_pie_chart_report_legend');
  const pieChartTotalLabel = doc.querySelector('.export_html_pie_chart_total_label') || '';
  const chartNameBottom = doc.querySelector('.export_html_chart_name_bottom') || '';
  const legend = barsLegend || milestoneLegend || pieChartLegend;

  const chartContainer = document.createElement('div');

  chartContainer.style.display = 'flex';
  chartContainer.style.flexDirection = 'column';
  chartContainer.style.alignItems = 'center';

  const reportSnapshotWrapper = document.createElement('div');
  const chartInstance = echarts.getInstanceByDom(document.querySelector('[_echarts_instance_]'));
  /**
   *  на всякий делаем принудительный неанимированный ресайз для случая,
   *  когда между триггером перерисовки и нажатием кнопки экспорта прошло очень мало времени
   *  (большинство графиков анимированные, и есть такие, в которых долгие анимации,
   *  и мы можем получить недорисованный график)
   *  и вдобавок Promise
   */

  chartInstance.resize({
    silent: true,
    animation: {
      duration: 0,
    },
  });

  await new Promise(resolve => {
    setTimeout(resolve, 50);
  });

  const chartImage = new Image();

  reportSnapshotWrapper.append(chartImage);
  chartImage.style.width = '80%';
  chartImage.src = chartInstance.getDataURL({ pixelRatio: 2 });
  // reportSnapshotWrapper.style.display = 'block';
  reportSnapshotWrapper.style.width = `${config.width}px`;
  reportSnapshotWrapper.style.display = 'flex';
  reportSnapshotWrapper.style.justifyContent = 'center';
  // reportSnapshotWrapper.style.visibility = 'visible';

  if (config.chartType && config.chartType === 'pie') {
    reportSnapshotWrapper.style.width = '400px';
  }

  chartContainer.append(reportSnapshotWrapper);
  chartContainer.append(pieChartTotalLabel);
  chartContainer.append(chartNameBottom);

  if (legend) {
    legend.style.display = 'flex';
    legend.style.alignItems = 'center';
    legend.style.justifyContent = 'center';
    // legend.style.width = '100%';

    if (barsLegend) {
      legend.style.paddingTop = '16px';
    }

    const clonedLegend = legend.cloneNode(true);

    Array.from(clonedLegend.childNodes).forEach(node => {
      if (node.classList.contains('disabled')) {
        clonedLegend.removeChild(node);
      }
    });

    chartContainer.append(clonedLegend);
  }

  return `
  <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <title>${fileName}</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
          background-color: #fff;
        }
        header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #666666;
          padding: 12px 16px 8px;
          font-size: 12px;
          background: #CCDDDB;
        }
        main {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 90vh;
        }
        .export_html_report_toolbar {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: flex-start;
          width: 100%;
          font-size: 12px;
          color: #191919;
          border-bottom: 1px solid #e5e5e5;
        }
        .export_html_report_chart {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .export_html_box {
          width: 35px;
          height: 20px;
          border-radius: 2px;
        }
        .export_html_icon {
          display: flex;
          align-items: center;
        }
        .export_html_name {
          font-size: 12px;
          color: #191919;
          padding-left: 8px;
          margin-right: 24px;
        }
        .export_html_legend_item {
          display: flex;
          align-items: center;
        }
        .export_html_chart_name_bottom {
          width: 100%;
          text-align: center;
          color: #191919;
          font-size: 16px;
          bottom: 106px;
        }
        .export_html_milestone_chart_legend {
          width: 100%;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 20px;
          padding: 20px 10px 0;
        }
        .export_html_milestone_chart_legend.export_html_milestone_chart_legend__no_padding {
          padding: 0;
        }
        .export_html_milestone_chart_legend_item {
          display: flex;
          gap: 8px;
          align-items: center;
          font-size: 12px;
        }
        .export_html_color_box {
          border-radius: 4px;
          min-width: 35px;
          min-height: 20px;
        }
        .export_html_pie_chart_report_wrapper {
          display: flex;
          flex-direction: column;
          gap: 24px;
          align-items: center;
          justify-content: center;
        }
        .export_html_pie_chart_total_label {
          font-size: 16px;
          text-align: center;
          padding: 55px 0 72px;
        }
        .export_html_pie_chart_total_label.span {
          font-weight: 700;
        }
        .export_html_pie_chart_report_legend {
          display: flex;
          flex-direction: row;
          justify-content: center;
          overflow: auto;
          gap: 12px;
          padding-right: 5px; 18px;
          padding: 55px 0 72px;
        }
        .export_html_pie_chart_report_legend > div {
          width: 100%;
        }
        .export_html_pie_chart_report_legend_item {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .export_html_pie_chart_report_legend_box {
          border-radius: 2px;
          border: none;
        }
        .export_html_pie_chart_report_legend_name {
          font-size: 16px;
          color: #191919;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-wrap: nowrap;
        }
        footer {
          font-size: 12px;
          color: #b2b2b2;
          text-align: left;
          position: absolute;
          bottom: 0;
          width: 100%;
        }
      </style>
    </head>
    <body>
      <header>
        <div class="export_html_header_logo">
          <svg width="152" height="24" viewBox="0 0 152 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M87.5128 6.44728H92.2964C93.286 6.44728 94.0894 5.58413 94.0894 4.51932C94.0894 3.45451 93.2856 2.59135 92.2964 2.59135H79.1431C78.1527 2.59135 77.3499 3.45451 77.3499 4.51932C77.3499 5.58413 78.1533 6.44728 79.1425 6.44728H83.9261V19.3004C83.9261 20.3641 84.7294 21.2285 85.7202 21.2285C86.7103 21.2285 87.5128 20.3641 87.5128 19.3004V6.44728Z" fill="#00564C"/>
            <path d="M69.578 6.44728H74.3622C75.3524 6.44728 76.1552 5.58413 76.1552 4.51932C76.1552 3.45451 75.3524 2.59135 74.3616 2.59135H61.2093C60.2187 2.59135 59.4163 3.45451 59.4163 4.51932C59.4163 5.58413 60.2187 6.44728 61.2093 6.44728H65.9913V19.3004C65.9913 20.3641 66.7948 21.2285 67.785 21.2285C68.7757 21.2285 69.578 20.3641 69.578 19.3004V6.44728Z" fill="#00564C"/>
            <path d="M55.9729 21.2201C55.9938 21.2191 56.0148 21.2174 56.0356 21.2145L56.1106 21.2024C56.9662 21.0556 57.6215 20.2612 57.6215 19.3004V4.51932C57.6215 3.45451 56.8186 2.59135 55.8284 2.59135C54.8377 2.59135 54.0344 3.45451 54.0344 4.51932V14.8373L43.9108 3.53705C43.5596 3.14481 43.1494 2.87279 42.7358 2.72708C42.5322 2.6401 42.3104 2.5919 42.079 2.5919C41.9189 2.5919 41.7649 2.61517 41.6185 2.65727C41.6147 2.65851 41.611 2.65953 41.6073 2.66052C41.6028 2.66175 41.5983 2.66294 41.5943 2.66448C41.5472 2.67833 41.5028 2.69495 41.4583 2.71157C41.4462 2.71545 41.4326 2.72099 41.42 2.72653C40.7555 3.00907 40.2844 3.70492 40.2844 4.51932V19.301C40.2844 20.3647 41.0872 21.229 42.078 21.229C43.0682 21.229 43.8705 20.3647 43.8705 19.301V9.05172L53.9453 20.2949C54.5414 20.9614 55.3113 21.2844 55.9729 21.2201Z" fill="#00564C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.9145 17.3751L35.1183 20.031V20.0316C35.5924 21.0758 36.68 21.5351 37.5478 21.0576C38.4177 20.58 38.7374 19.3457 38.2647 18.3019L31.6912 3.79998C31.2726 2.87534 30.3729 2.41107 29.5696 2.64598C28.9671 2.74016 28.3977 3.16675 28.0863 3.83434L21.3815 18.2726C20.8983 19.3129 21.2255 20.5412 22.1115 21.0177C22.9971 21.4936 24.1071 21.0353 24.5907 19.9956L25.8708 17.2376C26.0766 17.3252 26.2984 17.3751 26.532 17.3751H33.9145ZM27.5994 13.5198L29.9116 8.54193L32.1673 13.5198H27.5994Z" fill="#00564C"/>
            <path d="M4.41415 21.2287H17.5659C18.5566 21.2287 19.3589 20.3646 19.3589 19.3008V12.2315C19.3589 11.1667 18.5566 10.3036 17.5659 10.3036H12.1857C11.1949 10.3036 10.3921 11.1667 10.3921 12.2315C10.3921 13.2969 11.1955 14.1595 12.1862 14.1595H15.7729V17.3728H6.20775V6.44763H17.5664C18.5572 6.44763 19.3595 5.58448 19.3595 4.51966C19.3595 3.45484 18.5572 2.59168 17.5659 2.59168H4.41364C3.42342 2.59168 2.62057 3.45428 2.62109 4.51966V19.3008C2.62109 20.3646 3.42394 21.2287 4.41415 21.2287Z" fill="#00564C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M134.387 21.2337H147.539C148.529 21.2337 149.332 20.3695 149.332 19.3058V4.52467C149.332 3.45985 148.529 2.59669 147.539 2.59669H134.387C133.396 2.59669 132.594 3.45985 132.594 4.52467V19.3058C132.594 20.3695 133.396 21.2337 134.387 21.2337ZM136.18 17.3789V6.45421H145.745V17.3789H136.18Z" fill="#00564C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M126.749 14.1645H129.005C129.995 14.1645 130.799 13.3019 130.799 12.2366V4.52467C130.799 3.45985 129.996 2.59669 129.005 2.59669H115.853C114.862 2.59669 114.06 3.45985 114.06 4.52467V19.3052C114.06 20.3689 114.862 21.2333 115.853 21.2333C116.843 21.2333 117.647 20.3689 117.647 19.3052V14.164H121.88L127.123 20.3009C128.032 21.3157 129.346 21.5396 130.061 20.8016C130.774 20.062 130.616 18.641 129.707 17.6271L126.749 14.1645ZM117.649 6.45366H127.213V10.3096H117.649V6.45366Z" fill="#00564C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M99.1161 14.1645H110.474C111.464 14.1645 112.268 13.3019 112.268 12.2366V4.52467C112.268 3.45985 111.464 2.59669 110.474 2.59669H97.3219C96.3317 2.59669 95.5284 3.45985 95.5284 4.52467V19.3058C95.5284 20.3695 96.3317 21.2337 97.3219 21.2337C98.3126 21.2337 99.1161 20.3695 99.1161 19.3058V14.1645ZM99.1174 6.45366H108.683V10.3096H99.1174V6.45366Z" fill="#00564C"/>
          </svg>
        </div>
        <div class="export_html_header_date">
          ${headerDateCreation}
        </div>
      </header>
      <main>
        ${range.length ? `<div class="export_html_report_toolbar">
          <p style="margin: 0; padding: 8px 16px">${range}</p>
        </div>` : ''}
        ${year ? `<div class="export_html_report_toolbar">
          <p style="margin: 0; padding: 8px 16px; color: #212121">${year}</p>
        </div>` : ''}
        <div class="export_html_report_chart">${chartContainer.outerHTML}</div>
      </main>
      <footer><p style="margin: 0; padding: 8px 16px">${__('excel_export_footer_postfix1')}</p></footer>
    </body>
  </html>`;
}
